module.exports = function () {
    // Store a reference to the table of contents instead of querying it each time
    var $tableOfContents = $('.table-of-contents');

    // Start with an impossible previous position to force us to compute everything the first
    // time the handler is run
    var previousPosition = Infinity;

    // If there's no table of contents, don't do anything
    if ($tableOfContents.length) {

        var forceRefresh = false;

        $(window).resize(function () {
            forceRefresh = true;
        });

        // We use setInterval here at roughly 40x per second, instead of binding to the window
        // scroll event. This is because of the potentially large amount of events that could
        // be generated from scrolling, and also to accommodate devices that don't register
        // events during the inertial scroll after the user lets go of the touch but before
        // the window has finished scrolling.
        setInterval(function () {

            // Determine the position the user is currently scrolled to
            var scrollPosition = $(window).scrollTop();

            // We only run all of the logic if this is the first run or if the scroll position
            // has changed since the last run. This reduces the frequency that we actually need
            // to run the logic.
            if (!forceRefresh && isFinite(previousPosition) && previousPosition === scrollPosition) {
                previousPosition = scrollPosition;
                return;
            }

            forceRefresh = false;

            // Store our current position
            previousPosition = scrollPosition;

            // Calculate the position at which we change from non-sticky to sticky mode. We do
            // this by using a sentinal element which is located immediately after the table of
            // contents. We need this because when the table of contents changes to sticky, we
            // otherwise wouldn't be able to locate when it's original position ended.
            var targetTopPosition = $(window).scrollTop() +
                $tableOfContents.nextAll('.table-of-contents-sentinal')[0].getBoundingClientRect().top - $('.main-header').outerHeight(true);

            // If we're not in sticky mode, remove the height of the table of contents to find
            // the position where it starts.
            if (!$tableOfContents.hasClass("table-of-contents-sticky")) {
                targetTopPosition -= $tableOfContents.height();
            }

            // Get a reference to the first container located in the table of contents.
            var $tableOfContentsContainer = $tableOfContents.children('.table-of-contents__container');

            // If we've hit the scroll threshold, we turn sticky on
            if (scrollPosition >= targetTopPosition) {

                // Temporarily disable height transitions
                $tableOfContentsContainer.first().css("transition", "none");

                // We need to wait till the next runloop to make sure that the transition is actually off
                setTimeout(function () {

                    // Make the table of contents sticky
                    $tableOfContents.addClass('table-of-contents-sticky');

                    // Display the spacer which is the same height as the table of contents
                    // itself. This preserves the spacing when we make our transition
                    $tableOfContents.nextAll('.table-of-contents-spacer').first().css({
                        'display': 'block'
                    });

                    // We'll need to determine the height that we need for the spacer. This
                    // depends on some other logic and whether the dropdown is open or not
                    var spacerHeight = 0;

                    // If the table of contents is open
                    if ($tableOfContents.hasClass('table-of-contents-open')) {

                        // Determine the position and height of the table of contents
                        var position = $tableOfContents.find('ul').position();
                        var height = $tableOfContents.find('ul').outerHeight();

                        // Set the height of the container to be the height of the table of
                        // contents.
                        $tableOfContentsContainer.css('height', position.top + height + 'px');

                        // Determine the position and height of the header for the dropdown
                        var $tableOfContentsSelectHeader =
                            $tableOfContents.find('.table-of-contents-select-header');
                        var position = $tableOfContentsSelectHeader.position();
                        var height = $tableOfContentsSelectHeader.outerHeight();

                        // The spacer should be the same height as the bottom of the select header
                        spacerHeight = position.top + height;
                    } else {

                        // Determine the position and height of the header for the dropdown
                        var $tableOfContentsSelectHeader =
                            $tableOfContents.find('.table-of-contents-select-header');
                        var position = $tableOfContentsSelectHeader.position();
                        var height = $tableOfContentsSelectHeader.outerHeight();

                        // Set the height of the container to be the bottom position of the header
                        // position of the dropdown
                        $tableOfContentsContainer.css('height', position.top + height + 'px');

                        // The spacer should be the same height as the height of the table of contents
                        spacerHeight = $tableOfContents.height();
                    }

                    // We need to re-enable the table of contents transition in the next runloop
                    // so that the changes don't cancel out
                    setTimeout(function () {

                        // Set the spacer height
                        $tableOfContents.nextAll('.table-of-contents-spacer').first().css({
                            'height': spacerHeight + 'px'
                        });

                        // Re-enable transitions
                        $tableOfContentsContainer.first().css("transition", "");
                    },
                        0);
                },
                    0);
            } else {

                // Disable transitions on the container
                $tableOfContentsContainer.css("transition", "none");

                // We need to wait till the next runloop to make sure that the transition is actually off
                setTimeout(function () {

                    // Set the table of contents to non-sticky mode
                    $tableOfContents.removeClass('table-of-contents-sticky');

                    // Hide the spacer
                    $tableOfContents.nextAll('.table-of-contents-spacer').css({
                        'display': 'none'
                    });

                    // Calculate the correct height of the container
                    if ($tableOfContents.hasClass('table-of-contents-open')) {

                        // Set the container height to be the height of the table of contents
                        var position = $tableOfContents.find('ul').position();
                        var height = $tableOfContents.find('ul').outerHeight();
                        $tableOfContentsContainer.css('height', position.top + height + 'px');
                    } else {

                        // Set the container height to be the bottom of the select header
                        var $tableOfContentsSelectHeader =
                            $tableOfContents.find('.table-of-contents-select-header');
                        var position = $tableOfContentsSelectHeader.position();
                        var height = $tableOfContentsSelectHeader.outerHeight();
                        $tableOfContentsContainer.css('height', position.top + height + 'px');
                    }

                    // Re-enable transitions in the next runloop to avoid cancelling the change out
                    setTimeout(function () {
                        $tableOfContentsContainer.first().css("transition", "");
                    },
                        0);
                },
                    0);
            }

            var contentSelector = '#main-content';

            // Locate the element which is currently at the bottom of the header, halfway across the page
            var $elem = ICF.Utils.ElementAtPointInElement($(window).width() / 2,
                180,
                $(contentSelector));

            var $parents = $elem.parentsUntil(contentSelector);

            var $previousParent = $elem.parent().is(contentSelector)
                ? $elem
                : ($parents.length >= 2 ? $($parents[$parents.length - 2]) : $([]));

            // Get the select header and the previously active link
            var $tableOfContentsSelectHeader = $tableOfContents.find('.table-of-contents-select-header');
            var $oldActive = $tableOfContents.find('.table-of-contents-link-active');

            // If there was an element located within the content container, we'll
            // locate and select the appropriate table of contents link
            if ($previousParent.length) {

                // Find either the parent which is a page section header,
                // or locate the nearest one before where we are
                var $sectionHeader = $previousParent;
                if (!$previousParent.hasClass('page-section-header')) {
                    $sectionHeader = $previousParent.prevAll('.page-section-header');
                }

                if ($sectionHeader.length) {
                    // Locate the correct table of contents link
                    var $tableOfContentsLink = $tableOfContents.find('[href="#' + $sectionHeader.attr('id') + '"]');

                    // Remove the active state from the previous element and make the new element
                    // active
                    $oldActive.removeClass('table-of-contents-link-active');
                    var $active = $tableOfContentsLink.parents('li').first()
                        .addClass('table-of-contents-link-active');

                    // Set the header of the dropdown to the current link title and index
                    $tableOfContentsSelectHeader.find('.table-of-contents-index')
                        .text(Math.max(1, $active.index() + 1));
                    $tableOfContentsSelectHeader.find('.table-of-contents-select-text').text($active.text());
                }
            }
        },
            25);

        // Get a reference to the containers
        var $linksContainer = $tableOfContents.find('.table-of-contents-links-container');
        var $links = $tableOfContents.find('.table-of-contents-links');

        // Get the widths of the containers
        var linksContainerWidth = $linksContainer.width();
        var linksWidth = $links.width();

        // Calculate if we need to show the arrows still
        if (linksWidth > linksContainerWidth) {
            $linksContainer.addClass('table-of-contents-list-scroll-right');
        }

        // When we click a link in the table of contents, we need to scroll to the correct
        // page section
        $tableOfContents.find('a.table-of-contents-anchor').click(function (e) {
            e.preventDefault();

            // Get the element we're scolling to
            var $scrollElem = $($(this).attr('href'));

            // If we didn't find a page section, return early
            if (!$scrollElem.length) {
                return;
            }

            // Get the top position of the element we're scrolling to relative to the window
            var offsetTop = $scrollElem.offset().top;

            // Create a duplicate of the table of contents and force it to be sticky
            // so that we're able to determine the height of a sticky header. This is necessary
            // because when we scroll to the page section, we need to ensure that the header
            // isn't overlapped by the table of contents. And since we could be coming from
            // a non-sticky mode, and we're guaranteed to end up in sticky mode, we need to
            // calculate the final height of the table of contents, not the current one.
            var $duplicate = $tableOfContents.clone();
            $duplicate.css('visibility', 'hidden');
            $duplicate.addClass('table-of-contents-sticky');
            $('body').append($duplicate);

            // Ensure that the layout of the duplicate has completed
            setTimeout(function () {

                // Get the position and height of the header of the dropdown
                var heightOffset = $('.main-header').outerHeight(true);

                // Remove a few pixels to give us a bit more breathing room at the end of the scroll
                var tableOfContentsOffset = $tableOfContents.outerHeight(true);
                var scrollOffset = offsetTop - tableOfContentsOffset - heightOffset;

                // Remove the duplicate table of contents
                $duplicate.remove();

                // Animate a scroll to the page section
                $('html, body').animate({
                    scrollTop: scrollOffset
                },
                    750);

                // Close the table of contents
                $tableOfContents.removeClass('table-of-contents-open');
            }, 0);
        });

        // Handle the opening and closing of the table of contents
        $tableOfContents.find('.table-of-contents-select-header').click(function () {

            // If it's already open, we'll close it
            if ($tableOfContents.hasClass('table-of-contents-open')) {

                // Remove the open class
                $tableOfContents.removeClass('table-of-contents-open');

                // Get the position and height of the dopdown header
                var $tableOfContentsSelectHeader = $tableOfContents.find('.table-of-contents-select-header');
                var position = $tableOfContentsSelectHeader.position();
                var height = $tableOfContentsSelectHeader.outerHeight();

                // Set the header of the container to the bottom of the dropdown header
                $tableOfContents.children('.table-of-contents__container').first().css('height', position.top + height + 'px');
            } else {

                // Add the open class
                $tableOfContents.addClass('table-of-contents-open');

                // Get the height and position of the ul containing the links
                var position = $tableOfContents.find('ul').position();
                var height = $tableOfContents.find('ul').outerHeight();

                // Set the height of the container to the bottom position of the links ul
                $tableOfContents.children('.table-of-contents__container').first().css('height', position.top + height + 'px');
            }
        });

        // Handler for the next/previous buttons in the table of contents when overflowing
        // on desktop
        var scrollClickHandler = function (direction) {

            // Get a reference to the containers
            var $linksContainer = $tableOfContents.find('.table-of-contents-links-container');
            var $links = $tableOfContents.find('.table-of-contents-links');

            // Get the container widths
            var linksContainerWidth = $linksContainer.outerWidth();
            var linksWidth = $links.outerWidth();

            // The logic to apply the position will be the same regardless of direction,
            // so we declare it here
            var newLeftPosition = 0;

            // Get the current position in the list
            var currentScrollIndex = $links.data('scrollIndex');

            // Next button direction
            if (direction == 1) {

                // Get the current left position
                var originalLeftPosition = $links.position().left;

                // Get the current link index (to a maximum of the number of items)
                var currentScrollIndex = Math.min($links.find('.table-of-contents-link').length,
                    currentScrollIndex + 1);

                // Get the current link
                var $link = $($links.find('.table-of-contents-link')[currentScrollIndex]);

                // Get the position of the right edge relative to the inner container
                var rightPosition = -originalLeftPosition + $linksContainer.outerWidth() + 33;

                // Declare the computed positions
                var linkLeftPosition, linkRightPosition;

                // Search the links to find one that contains the right edge of the outer container
                $links.find('.table-of-contents-link').each(function () {

                    // Calculate the positions
                    linkLeftPosition = $(this).position().left;
                    linkRightPosition = linkLeftPosition + $(this).outerWidth() + 32;

                    // If we found the link, abort the loop
                    if (linkLeftPosition <= rightPosition && linkRightPosition >= rightPosition) {
                        return false;
                    }
                });

                // Calculate the new left position of the inner container
                newLeftPosition = (linksContainerWidth - linkRightPosition + 12);

                // If we didn't move, we're at the end, so don't continue to scroll
                if (newLeftPosition == originalLeftPosition) {
                    currentScrollIndex--;
                }
            }
            // For previous button click
            else {

                // Get the current left position of the inner container
                var originalLeftPosition = $links.position().left;

                // Get the current link index, with a minimum of 0
                var currentScrollIndex = Math.max(0, currentScrollIndex - 1);

                // Get the current link
                var $link = $($links.find('.table-of-contents-link')[currentScrollIndex]);

                // Get the new left position
                newLeftPosition = -$link.position().left + 12;

                // The inner container cannot be positive, so limit it to 0
                newLeftPosition = Math.min(0, newLeftPosition);

                // If we didn't move, we're at the beginning, so don't continue to scroll
                if (newLeftPosition == originalLeftPosition) {
                    currentScrollIndex++;
                }
            }

            // Set the left position of the inner container
            $links.css('left', newLeftPosition + 'px')

            // Set the new link index
            $links.data('scrollIndex', currentScrollIndex);

            // Calculate if we need to show the arrows still
            if (linksWidth > linksContainerWidth) {

                // Get the right edge position
                var newLinksRightPosition = newLeftPosition + $links.outerWidth();

                // If we're not at the beginning (left position of 0) show the left
                // arrow, otherwise hide it
                if (newLeftPosition < 0) {
                    $linksContainer.addClass('table-of-contents-list-scroll-left');
                } else {
                    $linksContainer.removeClass('table-of-contents-list-scroll-left');
                }

                // If we're not at the end, show the right arrow, otherwise hide it
                if (newLinksRightPosition > linksContainerWidth) {
                    $linksContainer.addClass('table-of-contents-list-scroll-right');
                } else {
                    $linksContainer.removeClass('table-of-contents-list-scroll-right');
                }
            }
            // If the inner container isn't wider than the outer container, hide both
            // of the arrows. This shouldn't happen here, but just in case.
            else {
                $linksContainer.removeClass('table-of-contents-list-scroll-left');
                $linksContainer.removeClass('table-of-contents-list-scroll-right');
            }
        };

        // Bind the left button click handler
        $tableOfContents.find('.table-of-contents-left-button').click(function () {
            scrollClickHandler(0);
        });

        // Bind the right button click handler
        $tableOfContents.find('.table-of-contents-right-button').click(function () {
            scrollClickHandler(1);
        });

        // Bind the click handler for the scroll to top button
        $tableOfContents.find('.table-of-contents__scroll-to-top').click(function () {

            // Animate the scroll to the top of the page
            $('html, body').animate({
                scrollTop: 0
            },
                750);

            // Close the table of contents
            $tableOfContents.removeClass('table-of-contents-open');
        });

        // Bind the click handler for the scroll to top mobile button
        $tableOfContents.find('.table-of-contents__mobile-button-scroll-to-top').click(function () {

            // Animate the scroll to the top of the page
            $('html, body').animate({
                scrollTop: 0
            }, 750);
        });

        var $progressBar = $('.table-of-contents-link').find('.progress-bar');

        var calculateProgressBarWidth = function ($bar) {                        
            var headerOffset = 80;
            var tableOfContentsOffset = $tableOfContents.outerHeight(true);

            var $linkItem = $bar.closest('.table-of-contents-link');
            var $link = $linkItem.find('a');
            var $target = $($link.attr('href'));
            var targetEl = $target[0];
            var targetBounds = targetEl.getBoundingClientRect();

            if (targetBounds.top > window.innerHeight) {
                ICF.Utils.ProgressBar.FillBar($bar, '0%');
                return;
            }

            var $correspondingElements = $target.nextUntil('.page-section-header').filter(function (index) {                
                var positionPropertyValue = $(this).css('position');
                var isStaticOrRelative = positionPropertyValue == 'static' || positionPropertyValue == 'relative';
                var hasHeight = (this).getBoundingClientRect().height > 0;
                return isStaticOrRelative && hasHeight;
            });

            if (!$correspondingElements.length) {
                ICF.Utils.ProgressBar.FillBar($bar, '0%');
                return;
            }

            var lastEl = $correspondingElements.last()[0];
            var lastElBounds = lastEl.getBoundingClientRect();

            if (lastElBounds.bottom - headerOffset < 0) {
                ICF.Utils.ProgressBar.FillBar($bar, '100%');
                return;
            }

            var height = 0;
            $correspondingElements.each(function (i, el) {
                var $el = $(el);
                var elHeight = $el.outerHeight(true);

                height += elHeight;
            });

            var ratio = (height - lastElBounds.bottom + headerOffset + tableOfContentsOffset) / height;
            var percentage = (ratio * 100) + '%';

            ICF.Utils.ProgressBar.FillBar($bar, percentage);
        };

        var adjustProgressBars = function () {
            $progressBar.each(function (i, el) {

                var $bar = $(el);

                calculateProgressBarWidth($bar);
            });
        };

        $(window).scroll(function () {
            requestAnimationFrame(function () {
                adjustProgressBars();
            });
        });

        $(window).resize(function () {
            requestAnimationFrame(function () {
                adjustProgressBars();
            });
        });

        $('.main-header').addClass('header--with-submenu');
    }
};